import { render, staticRenderFns } from "./goodEdit.vue?vue&type=template&id=42d8a7fe&scoped=true&"
import script from "./goodEdit.vue?vue&type=script&lang=js&"
export * from "./goodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8a7fe",
  null
  
)

export default component.exports